import { createEssentials } from '@wix/fe-essentials-standalone';
import { createGlobalConfig, panoramaClientFactory, PanoramaPlatform } from '@wix/panorama-client-web';
import { PremiumEssentialsProvider } from '@wix/premium-fed-sdk/@premium-essentials';
import { useHttpClientSiteLevel } from '@wix/premium-fed-sdk/@premium-essentials-adaptors';
import React from 'react';
const globalConfig = createGlobalConfig();
export const PackagePickerEssentialsProvider = _ref => {
  let {
    children,
    siteGuid,
    artifactId,
    version,
    Trans,
    componentId,
    sentryDsn,
    locale,
    userId
  } = _ref;
  const essentials = createEssentials({
    environment: {
      language: locale ?? 'en',
      artifactId,
      version
    },
    i18n: {}
  });
  const panoramaClient = panoramaClientFactory({
    baseParams: {
      platform: PanoramaPlatform.Standalone,
      fullArtifactId: artifactId,
      artifactVersion: version,
      componentId,
      msid: siteGuid,
      uuid: userId
    },
    pluginParams: {
      sentry: window.Sentry,
      sentryDsn
    }
  }).withGlobalConfig(globalConfig).client().createClientForComponent();
  const {
    httpClient: signedHttpClient,
    isLoading
  } = useHttpClientSiteLevel({
    siteId: siteGuid,
    httpClientOptions: {
      ...essentials.httpClient.options
    }
  });
  if (isLoading) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(PremiumEssentialsProvider, {
    Trans: Trans,
    i18n: essentials.i18n,
    biLogger: essentials.biLogger,
    httpClient: signedHttpClient ?? essentials.httpClient,
    panorama: panoramaClient
  }, children);
};
//# sourceMappingURL=PackagePickerEssentialsProvider.js.map